module.exports = __webpack_public_path__ + "img/STARCH.f70b6c97.png";